// @flow

/**
 * Data Display Context
 * Provides the current message's dataDisplays map to child components
 */

import { createContext, useContext } from 'react';

export type DataDisplayContextValue = {
  /** Map of displayId → display definition for the current message */
  dataDisplays: { [string]: Object },
};

export const DataDisplayContext = createContext<?DataDisplayContextValue>(null);

/**
 * Hook to access the current message's data display definitions
 */
export function useDataDisplays(): { [string]: Object } {
  const context = useContext(DataDisplayContext);
  return context?.dataDisplays || {};
}
